<template>

  <div class="wrap">
    <h3>{{station.name}}</h3>
    <h4>Current conditions</h4>
    <p>{{ formatted_time }}</p>
    <table>
      <tr>
        <th>Temperature</th>
        <th>Pressure</th>
        <th>Humidity %</th>
        <th>Rainfall Inches</th>
      </tr>
      <tr>
        <td>{{station.temp}}</td>
        <td>{{station.pressure_in_hg}}</td>
        <td>{{station.humidity}}</td>
        <td>{{station.rain}}</td>

      </tr>
    </table>

    <p><label>Wind Speed:</label> {{station.wind_speed_mph}} MPH from the {{formatted_wind_dir(station.wind_dir_deg)}}</p>

    <p><label>Wind Gust:</label> {{station.wind_gust_mph}} MPH from the {{formatted_wind_dir(station.wind_gust_direction_degrees)}}</p>

    <p v-if="station.solar_radiation"><label>Solar Radiation:</label> <b>{{station.solar_radiation}}</b> W/m^2</p>

    <table class="table table-bordered">
      <tr>
        <th>Soil Conditions</th>
        <th>Temperature (F)</th>
        <th>Moisture (cB)</th>
      </tr>
      <tr>
        <th>2" Depth</th>
        <td>{{station.soil_temp_1}}</td>
        <td>{{station.soil_moist_1}}</td>
      </tr>
      <tr>
        <th>5" Depth</th>
        <td>{{station.soil_temp_2}}</td>
        <td>{{station.soil_moist_2}}</td>
      </tr>
      <tr>
        <th>10" Depth</th>
        <td>{{station.soil_temp_3}}</td>
        <td>{{station.soil_moist_3}}</td>
      </tr>
      <tr>
        <th>15" Depth</th>
        <td>{{station.soil_temp_4}}</td>
        <td>{{station.soil_moist_4}}</td>
      </tr>
    </table>




  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: "WeatherStationDataView",
    props: {
      station: Object
    },
    methods: {
      formatted_wind_dir(degreesRaw) {

        if (isNaN(parseFloat(degreesRaw))) {
          return '--';
        }

        let degrees = parseFloat(degreesRaw);

        const lookups = [
          {deg: 0, disp: 'N',},
          {deg: 22.5, disp: 'NNE',},
          {deg: 45, disp: 'NE',},
          {deg: 67.5, disp: 'ENE',},
          {deg: 90, disp: 'E',},
          {deg: 112.5, disp: 'ESE',},
          {deg: 135, disp: 'SE',},
          {deg: 157.5, disp: 'SSE',},
          {deg: 180, disp: 'S',},
          {deg: 202.5, disp: 'SSW',},
          {deg: 225, disp: 'SW',},
          {deg: 247.5, disp: 'WSW',},
          {deg: 270, disp: 'W',},
          {deg: 292.5, disp: 'WNW',},
          {deg: 315, disp: 'NW',},
          {deg: 337.5, disp: 'NNW',},
        ];

        let match = lookups.find(({deg, disp}) => {
          return (degrees >= (deg-11.25) && degrees <= (deg+11.25));
        });
        if (match) {
          return match.disp;
        }

        return '?';
      }
    },
    computed: {
      formatted_time() {
        return moment(this.station.observation_time).format("dddd, MMMM Do YYYY, h:mm a")
      }
    }
  }
</script>

<style scoped>
  .wrap {
    padding: .5rem;
    border: 1px solid #333;
    margin: .5rem;
  }
  div {
    text-align: left;

  }

  label {
    font-weight: bold;
  }

  table {
    width: 100%;
  }

  div table td {
    text-align: center;
  }
</style>